<template>
  <div class="v5-card">
    <!-- Header -->
    <div class="v5-header">
      <div class="v5-header-top">
        <h3 class="v5-title">{{statSubtitle}}</h3>
        <select v-if="filter" :name="action" @change="ChangeDateDely($event)" v-model="timeserchtype" class="v5-select">
          <option value="today">Today</option>
          <option value="yesterday">Yesterday</option>
          <option value="tomorrow">Tomorrow</option>
          <option value="thisweek">This week</option>
          <option value="lastweek">Last week</option>
          <option value="This Month">This Month</option>
          <option value="Last Month">Last Month</option>
          <option value="This Year">This Year</option>
          <option value="betweendate">Between date</option>
        </select>
      </div>

      <!-- Filters -->
      <div v-if="filterseller && currentUser && currentUser.type && currentUser.role && currentUser.role.name" class="v5-filters">
        <div class="v5-filter-row">
          <div class="v5-filter-item" v-if="currentUser.role.name!='Seller' && currentUser.type!='Seller'">
            <v-select @search="getUsersDebance($event,'shipsen')" @input="CheckSellerProducts($event,action,'seller')" label="fullName" placeholder="Seller" :options="sellers" v-model="sellerdata" class="v5-filter-select"></v-select>
          </div>
          <div class="v5-filter-item">
            <v-select @search="getProducts($event,'shipsen')" @input="CheckSellerProducts($event,action,'product')" label="name" placeholder="Product" :options="products" v-model="productdata" class="v5-filter-select"></v-select>
          </div>
          <button class="v5-filter-clear" @click="removedata(action)">
            <i class="material-icons" style="font-size:16px">close</i>
          </button>
        </div>
        <div v-if="filter && timeserchtype=='betweendate'" class="v5-filter-date">
          <date-picker placeholder="Range date ..." format="YYYY-MM-DD" type="date" class="v5-datepicker" v-model="fromDate" range></date-picker>
          <button @click="FindRecordsBetweenDate()" :class="!fromDate?'noselect':''" :disabled="!fromDate" class="v5-filter-search">
            <i class="material-icons" style="font-size:18px">search</i>
          </button>
        </div>
      </div>
    </div>

    <!-- Donut chart -->
    <div class="v5-chart">
      <loading :active.sync="loading" :is-full-page="fullPage"></loading>
      <div :id="id"></div>
    </div>

    <!-- Status list with progress bars -->
    <div class="v5-body">
      <div v-if="dataChart" class="v5-items">
        <div v-for="(item, index) in filteredData" :key="index" class="v5-item">
          <div class="v5-item-left">
            <div class="v5-item-dot" :style="'background:'+item.colors"></div>
            <div class="v5-item-info">
              <span class="v5-item-name">{{item.name}}</span>
              <div class="v5-item-bar-wrap">
                <div class="v5-item-bar" :style="'width:'+getPercent(item.count)+'%; background:'+item.colors"></div>
              </div>
              <span class="v5-item-percent">{{getPercent(item.count)}}%</span>
            </div>
          </div>
          <span class="v5-item-count">{{item.count}}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "card-stats-v5",
  props: {
   loading:{required:false},
   statSubtitle: {default: "Traffic",},
   filter: {default: false,},
   id:{type:String},
   from:{},
   to:{},
   dataChart:{type:Array},
   label:{type:Array},
   timeserch:{},
   action: {},
   seller:{},
   product:{},
   sellers:{type:Array},
   products:{type:Array},
   currentUser:{type:Object},
    filterseller: {
      default: false,
    },
  },
  computed: {
    filteredData() {
      if (!this.dataChart) return [];
      return this.dataChart.filter(item => item.name != 'Shipped Daily');
    },
    totalCount() {
      return this.filteredData.reduce((sum, item) => sum + item.count, 0);
    },
  },
  data() {
    return {
      fullPage: false,
      myChart: "",
      timeserchtype:this.timeserch,
      fromDate:this.from,
      toDate:this.to,
      sellerdata:this.seller,
      productdata:this.product,
    };
  },
 watch: {
   'timeserch': function () {
      this.timeserchtype=this.timeserch;
   },
   'seller': function () {
      this.sellerdata=this.seller;
   },
   'product': function () {
      this.productdata=this.product;
   },
    dataChart: function () {
      if (this.myChart != null) this.myChart.destroy();
      this.drawChart(this.dataChart,this.label);
      this.myChart.render();
    },
  },
  async mounted(){
     await this.drawChart(this.dataChart,this.label);
     if (this.myChart) this.myChart.render();
  },
   methods: {
    getPercent(count) {
      return this.totalCount ? Math.round((count * 100) / this.totalCount) : 0;
    },
      ChangeDateCallcenter: function (val) {
         this.$emit("ChangeDateCallcenter", val);
    },
    FindRecordsBetweenDate: function (val) {
         this.$emit("FindRecordsBetweenDate", this.action,this.fromDate,this.toDate);
    },
      FindRecordsSellers: function (val) {
        this.$emit("FindRecordsSellers", this.action,this.sellerdata,this.productdata);
    },
    getUsersDebance: function (name) {
        this.$emit("getUsersDebance", name);
     },
    getProducts: function (name) {
        this.$emit("getProducts", name);
     },
    async CheckSellerProducts(seller,action,model){
       this.$emit("CheckSellerProducts", seller,action,model);
    },
    removedata: function (val) {
        this.$emit("removedata", this.action);
     },
     ChangeDateDely: function (val) {
         this.$emit("ChangeDateDely", val);
    },
    drawChart(chartData,label) {
      chartData = chartData.filter(function(item) { return item.name != 'Shipped Daily'; });
       var ctx = document.getElementById(this.id);
        this.myChart = new ApexCharts(ctx, {
		chart: {
			width: 220,
			type: 'donut',
			foreColor: 'rgba(255, 255, 255, 0.85)',
		},
		dataLabels: { enabled: true },
		series: chartData.map( el => el.count ),
		fill: {
			type: 'gradient',
			gradient: { gradientToColors: chartData.map( el => el.gradient ) },
		},
		colors: chartData.map( el => el.colors ),
		tooltip: { enabled: false, theme: 'dark' },
		legend: {
			show: false,
			formatter: function (val, opts) {
				return val + " - " + opts.w.globals.series[opts.seriesIndex]
			}
		},
		responsive: [{ breakpoint: 480, options: { chart: { width: 280 }, legend: { position: 'bottom' } } }]
	});
    },
   }
};
</script>
<style scoped>
/* V5 Card */
.v5-card {
  border-radius: 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
  border: 1px solid #e5e7eb;
  background: #ffffff;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  transition: all 0.3s ease;
}
.v5-card:hover {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

/* Header */
.v5-header {
  padding: 20px 24px 16px;
  border-bottom: 1px solid #f1f5f9;
}
.v5-header-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
}
.v5-title {
  font-size: 18px;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
}
.v5-select {
  appearance: auto;
  font-size: 13px;
  font-weight: 500;
  color: #475569;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 8px 14px;
  cursor: pointer;
  outline: none;
}
.v5-select:focus {
  border-color: #4285f4;
}

/* Filters */
.v5-filters {
  background: #f8fafc;
  border-radius: 10px;
  padding: 10px;
  margin-top: 12px;
}
.v5-filter-row {
  display: flex;
  align-items: center;
  gap: 6px;
}
.v5-filter-item {
  flex: 1;
  min-width: 0;
}
.v5-filter-select {
  font-size: 12px !important;
  background: #ffffff;
  border-radius: 8px;
}
.v5-filter-clear {
  width: 30px;
  height: 30px;
  min-width: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  border: none;
  background: #fee2e2;
  color: #ef4444;
  cursor: pointer;
  transition: all 0.2s;
}
.v5-filter-clear:hover { background: #fecaca; }
.v5-filter-date {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 8px;
}
.v5-datepicker { flex: 1; }
.v5-filter-search {
  width: 34px;
  height: 34px;
  min-width: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  border: none;
  background: #4285f4;
  color: #ffffff;
  cursor: pointer;
}
.v5-filter-search:hover { background: #3367d6; }
.v5-filter-search.noselect { opacity: 0.5; cursor: not-allowed; }

/* Donut chart */
.v5-chart {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px 20px 0;
  position: relative;
  max-height: 220px;
  overflow: hidden;
}

/* Status list */
.v5-body {
  padding: 8px 20px 16px;
  flex: 1;
  position: relative;
}
.v5-items {
  display: flex;
  flex-direction: column;
}
.v5-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 0;
  border-bottom: 1px solid #f1f5f9;
}
.v5-item:last-child {
  border-bottom: none;
}
.v5-item-left {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
  gap: 8px;
}
.v5-item-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}
.v5-item-info {
  flex: 1;
  min-width: 0;
}
.v5-item-name {
  font-size: 12px;
  font-weight: 600;
  color: #1e293b;
  text-transform: capitalize;
  display: inline;
  margin-right: 6px;
}
.v5-item-bar-wrap {
  width: 60px;
  height: 4px;
  background: #f1f5f9;
  border-radius: 2px;
  overflow: hidden;
  display: inline-block;
  vertical-align: middle;
}
.v5-item-bar {
  height: 100%;
  border-radius: 2px;
  transition: width 0.5s ease;
}
.v5-item-percent {
  font-size: 10px;
  color: #94a3b8;
  font-weight: 500;
  margin-left: 4px;
  display: inline-block;
  vertical-align: middle;
}
.v5-item-count {
  font-size: 13px;
  font-weight: 700;
  color: #1e293b;
  flex-shrink: 0;
  margin-left: 8px;
}
</style>
